import React, { useState } from 'react';
import { useAsync } from 'react-use';
import styled from 'styled-components/macro';
import { useSelector } from 'react-redux';

import selectors from 'state/selectors';
import services from 'services';

import { DownloadedReport } from 'models/response';

import { Container, Title } from '../styles';
import DownloadReportItem from '../components/DownloadReportItem';

const StyledLabel = styled.div`
  margin-right: 15px;
  font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
  width: 80px;
  text-align: left;
  font-weight: 100;
  align-self: center;
  color: ${({ theme }) => theme.colorPalette.grey.grey10};
`;

const WrapperList = styled.div`
  margin-top: 67px;
`;

export default () => {
  const [reports, setReports] = useState<DownloadedReport[]>([]);
  const idUser = useSelector(selectors.user.getIdUser);

  useAsync(async () => {
    if (idUser) {
      try {
        const { data } = await services.getReportListExecuted(idUser);
        setReports(data);
      } catch (e) {
        console.error(e);
      }
    }
  }, [idUser]);

  return (
    <>
      <Container>
        <Title>
          <h2>Report Archive</h2>
        </Title>

        <WrapperList>
          <StyledLabel>{reports.length} Results</StyledLabel>
          <div>
            {reports.map((report) => (
              <DownloadReportItem key={report.reportName} item={report} />
            ))}
          </div>
        </WrapperList>
      </Container>
    </>
  );
};
